<template>
    <div>
        <el-card class="box-card" v-loading="loading">
            <el-form :model="addCustomer" ref="addCustomerRef" :inline="true" label-width="68px">
                <el-form-item label="屈光状态">
                    <el-select v-model="addCustomer.diopterstate" placeholder="请选择" style="width: 100%">
                      <el-option label="请选择" value="0"></el-option>
                      <el-option label="正视" value="6"></el-option>
                      <el-option label="远视" value="2"></el-option>
                      <el-option label="近视" value="1"></el-option>
                      <el-option label="散光" value="7"></el-option>
                      <el-option label="老花" value="3"></el-option>
                      <el-option label="屈光参差" value="8"></el-option>
                      <el-option label="远视性弱视" value="9"></el-option>
                      <el-option label="散光性弱视" value="10"></el-option>
                      <el-option label="近视性弱视" value="11"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clickSave" v-if="SubRule_Customer_EditRegisterEyeinfo">保存修改</el-button>
                    <el-button type="info" @click="backCustomerManagement">返回</el-button>
                </el-form-item>
            </el-form>

            <!-- 屈光度 -->
            <el-table :data="diopterData" border stripe class="mt20">
              <el-table-column label="屈光度" align="center">
                <el-table-column label="OD(右眼)" align="center">
                  <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.righteyedegree" class="input_num"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.rightcolumnmirror" class="input_num"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.rightaxial" class="input_num"></el-input>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="OS(左眼)" align="center">
                  <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.lefteyedegree" class="input_num"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.leftcolumnmirror" class="input_num"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                    <template slot-scope="scope">
                      <el-input v-model="addCustomer.leftaxial" class="input_num"></el-input>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table-column>
            </el-table>

          <!-- ADD和调节幅度 -->
          <el-table :data="addData" border stripe class="mt20">
            <el-table-column label="ADD和调节幅度" align="center">
              <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.addtype" placeholder="请选择" style="width: 100%">
                    <el-option label="0.00D" value="0"></el-option>
                    <el-option label="0.50D" value="1"></el-option>
                    <el-option label="0.75D" value="2"></el-option>
                    <el-option label="1.00D" value="3"></el-option>
                    <el-option label="1.25D" value="4"></el-option>
                    <el-option label="1.50D" value="5"></el-option>
                    <el-option label="1.75D" value="6"></el-option>
                    <el-option label="2.00D" value="7"></el-option>
                    <el-option label="2.25D" value="8"></el-option>
                    <el-option label="2.50D" value="9"></el-option>
                    <el-option label="2.75D" value="10"></el-option>
                    <el-option label="3.00D" value="11"></el-option>
                    <el-option label="3.25D" value="12"></el-option>
                    <el-option label="3.50D" value="13"></el-option>
                    <el-option label="3.75D" value="14"></el-option>
                    <el-option label="4.00D" value="15"></el-option>
                    <el-option label="4.25D" value="16"></el-option>
                    <el-option label="4.50D" value="17"></el-option>
                    <el-option label="4.75D" value="18"></el-option>
                    <el-option label="5.00D" value="19"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
                <template slot-scope="scope">
                  <el-input v-model="addCustomer.amp"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 裸眼和矫正视力 -->
          <el-table :data="nakedEye" border stripe class="mt20">
            <el-table-column label="5m裸眼视力(5分记录法)" align="center">
              <el-table-column prop="odRight" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="最佳矫正视力(5分记录法)" align="center">
              <el-table-column prop="odRight1" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft1" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble1" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 瞳距，内透镜规格 -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="瞳距(单位:mm)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.interpupillary"></el-input>
              </template>
            </el-table-column>
              <el-table-column label="内置透镜规格(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.neizhitjggright" placeholder="请选择">
                    <el-option
                      v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="内置透镜规格(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.neizhitjggleft" placeholder="请选择">
                    <el-option
                      v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
          </el-table>
        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      loading: false,
      // 屈光度
      diopterData: [
        {
          rightEye1: '-3.50',
          rightEye2: '0.50',
          rightEye3: '85',
          leftEye1: '-3.25',
          leftEye2: '0.00',
          leftEye3: '0'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: '0.00',
          adjust: '0.00'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '3.5', osLeft: '3.5', ouDouble: '5.1', odRight1: '0.0', osLeft1: '0.0', ouDouble1: '0.0' }
      ],
      tongJuData: [
        { tongju: '60', leftEye: '无', rightEye: '无' }
      ],
      addCustomer: {
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        neizhitjggright: '8',
        neizhitjggleft: '8'
      },
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ],
      neizhitjgglist: [
        { value: '8', label: '无' },
        { value: '1', label: 'A' },
        { value: '2', label: 'B' },
        { value: '3', label: 'C' },
        { value: '4', label: 'D' },
        { value: '5', label: 'E' },
        { value: '6', label: 'F' },
        { value: '7', label: '其他' }
      ],
      SubRule_Customer_EditRegisterEyeinfo: false,
      parentdata: null
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Customer_EditRegisterEyeinfo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_EditRegisterEyeinfo = true
      }
    })
  },
  methods: {
    clickSave () {
      this.apieditRegisterEyeinfo()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetRegisterEyeinfo()
    },
    apigetRegisterEyeinfo: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRegisterEyeinfo, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.addCustomer.diopterstate = response.data.Diopterstate
            that.addCustomer.righteyedegree = response.data.Righteyedegree
            that.addCustomer.rightcolumnmirror = response.data.Rightcolumnmirror
            that.addCustomer.rightaxial = response.data.Rightaxial
            that.addCustomer.lefteyedegree = response.data.Lefteyedegree
            that.addCustomer.leftcolumnmirror = response.data.Leftcolumnmirror
            that.addCustomer.leftaxial = response.data.Leftaxial
            that.addCustomer.addtype = response.data.Addtype
            that.addCustomer.amp = response.data.Amp
            that.addCustomer.nakedrighteyedegree = response.data.Nakedrighteyedegree
            that.addCustomer.nakedlefteyedegree = response.data.Nakedlefteyedegree
            that.addCustomer.nakedbinoculusdegree = response.data.Nakedbinoculusdegree
            that.addCustomer.correctrighteyedegree = response.data.Correctrighteyedegree
            that.addCustomer.correctlefteyedegree = response.data.Correctlefteyedegree
            that.addCustomer.correctbinoculusdegree = response.data.Correctbinoculusdegree
            that.addCustomer.interpupillary = response.data.Interpupillary
            that.addCustomer.neizhitjggright = response.data.Neizhitjggright
            that.addCustomer.neizhitjggleft = response.data.Neizhitjggleft
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          that.loading = false
          Vue.prototype.FunLogError(error)
        })
    },
    apieditRegisterEyeinfo: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        diopterstate: that.addCustomer.diopterstate,
        righteyedegree: that.addCustomer.righteyedegree,
        rightcolumnmirror: that.addCustomer.rightcolumnmirror,
        rightaxial: that.addCustomer.rightaxial,
        lefteyedegree: that.addCustomer.lefteyedegree,
        leftcolumnmirror: that.addCustomer.leftcolumnmirror,
        leftaxial: that.addCustomer.leftaxial,
        addtype: that.addCustomer.addtype,
        amp: that.addCustomer.amp,
        nakedrighteyedegree: that.addCustomer.nakedrighteyedegree,
        nakedlefteyedegree: that.addCustomer.nakedlefteyedegree,
        nakedbinoculusdegree: that.addCustomer.nakedbinoculusdegree,
        correctrighteyedegree: that.addCustomer.correctrighteyedegree,
        correctlefteyedegree: that.addCustomer.correctlefteyedegree,
        correctbinoculusdegree: that.addCustomer.correctbinoculusdegree,
        interpupillary: that.addCustomer.interpupillary,
        neizhitjggright: that.addCustomer.neizhitjggright,
        neizhitjggleft: that.addCustomer.neizhitjggleft,
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditRegisterEyeinfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
